import React from 'react'
import './Clients.css'
import Logos, { image } from '../../assets'
import { useQuery } from "@tanstack/react-query"
import { getClientLogos } from '../../api/containersApi';

function Clients({headingText, subText}) {

    const { data: clientLogosList, isLoading, isError, refetch } = useQuery({
        queryKey: ['clientLogosList'],
        queryFn: () => (getClientLogos({auth_key: localStorage.getItem('sessionToken')})),
    });

    const featuredObjects = clientLogosList?.filter((imageDetail, index) => {
        return imageDetail?.is_featured === "1";
    })

    const unfeaturedObjects= clientLogosList?.filter((imageDetail, index) => {
        return imageDetail?.is_featured === "0";
    })    

    return (
        <div className='clients-section' id='clients'>

            <h1 className="feb_client_heading">{headingText}</h1>
            {/* data-aos="fade-up" data-aos-duration="1000" */}

            <div className="featured-Clients">
                {
                    featuredObjects?.map((featuredObject, index) => {
                        return <img src={featuredObject?.logo} alt="client" />
                    })
                }
            </div>

            <div className='logos-container'>
                <div className='logos desktopView'>
                    {
                        isLoading ? <section style={{textAlign: "center", width: "100%", padding: "1rem"}}>Loading Clients...</section> : 
                        <>
                            <div className='logos-slide'>
                                {unfeaturedObjects?.map((imageDetail, index) => (                            
                                    <img src={imageDetail?.logo} alt='client' />
                                ))}
                            </div>

                            <div className='logos-slide'>
                                {unfeaturedObjects?.map((imageDetail, index) => (
                                    <img src={imageDetail?.logo} alt='client' />
                                ))}
                            </div>
                        </>
                    }
                </div>

                <div className='logos phoneView'>
                    {
                        isLoading ? <section style={{textAlign: "center", width: "100%", padding: "1rem"}}>Loading Clients...</section> : 
                        <>
                            <div className='logos-slide'>
                                {clientLogosList?.map((imageDetail, index) => (                            
                                    <img src={imageDetail?.logo} alt='client' />
                                ))}
                            </div>

                            <div className='logos-slide'>
                                {clientLogosList?.map((imageDetail, index) => (
                                    <img src={imageDetail?.logo} alt='client' />
                                ))}
                            </div>
                        </>
                    }
                </div>

            </div>

            {/* <div className="line"></div> */}

        </div>
    )
}

export default Clients